/**
 * AuthLayout Component
 * Minimal layout for authentication pages (login, register, forgot password).
 */

import { Outlet } from 'react-router-dom';
import styles from './AuthLayout.module.css';

/**
 * Authentication layout - minimal wrapper for auth pages.
 * Each auth page handles its own internal layout.
 */
export const AuthLayout = () => {
  return (
    <div className={styles.layout}>
      <Outlet />
    </div>
  );
};
